import React from "react";
import { Shield, Award, FileCheck } from "lucide-react";

export default function MilitarySection() {
  return (
    <section
      id="military-rcmp"
      className="bg-[#122A1E] text-[#F4F4F1] border-b-2 border-[#122A1E]"
      data-testid="military-section"
      aria-labelledby="military-heading"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="font-mono-accent text-[11px] uppercase text-[#FF5A00]">
                ◆ Approved Carrier
              </span>
              <span className="h-[2px] w-16 bg-[#FF5A00]" />
            </div>
            <h2
              id="military-heading"
              className="font-display font-black uppercase tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
            >
              Military Moves &amp;
              <br />
              <span className="text-[#FF5A00]">RCMP Relocations.</span>
            </h2>
            <p className="mt-6 text-[#F4F4F1]/85 text-lg leading-relaxed max-w-xl">
              We proudly handle relocations for <strong>Canadian Armed Forces</strong>{" "}
              members and <strong>RCMP</strong> officers being posted across Canada.
              Direct-carrier service, transparent paperwork, and on-time delivery so
              you can focus on the transition — not the logistics of your RV,
              motorcycle, ATV, snowmobile, or boat.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div className="border-2 border-[#F4F4F1]/30 p-4">
                <FileCheck size={20} className="text-[#FF5A00] mb-2" strokeWidth={2.2} />
                <div className="font-display font-bold uppercase text-sm">
                  Relocation-Ready Paperwork
                </div>
                <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/70 mt-1">
                  Itemized invoicing · BOL · condition reports for claim files
                </div>
              </div>
              <div className="border-2 border-[#F4F4F1]/30 p-4">
                <Shield size={20} className="text-[#FF5A00] mb-2" strokeWidth={2.2} />
                <div className="font-display font-bold uppercase text-sm">
                  Posting-Cycle Priority
                </div>
                <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/70 mt-1">
                  APS &amp; posting-season priority scheduling
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="/#quote"
                className="inline-flex items-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] text-white font-display font-bold uppercase text-sm tracking-wider px-6 py-3 border-2 border-[#F4F4F1]"
                data-testid="military-cta-quote"
              >
                Request a Posting Quote →
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center gap-2 border-2 border-[#F4F4F1] hover:bg-[#F4F4F1] hover:text-[#122A1E] font-display font-bold uppercase text-sm tracking-wider px-6 py-3 transition-colors"
                data-testid="military-cta-contact"
              >
                Talk to Dispatch
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pl-8">
            <div className="border-2 border-[#F4F4F1]/40 p-6 md:p-8 bg-[#0C1D14]">
              <Award size={28} className="text-[#FF5A00]" strokeWidth={2.2} />
              <div className="mt-4 font-display font-black uppercase text-2xl leading-tight">
                Serving Those Who Serve.
              </div>
              <p className="mt-3 text-[#F4F4F1]/80 text-sm leading-relaxed">
                From CFB Esquimalt to CFB Halifax, Trenton to Cold Lake, and
                every RCMP detachment in between — we know posting cycles,
                short-notice moves, and the paperwork that comes with them.
              </p>
              <ul className="mt-5 space-y-2 font-mono-accent text-[10px] uppercase text-[#F4F4F1]/70">
                <li>◆ CAF postings coast-to-coast</li>
                <li>◆ RCMP transfer relocations</li>
                <li>◆ Recreational unit transport included</li>
                <li>◆ Same-driver, direct-carrier accountability</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
